import './App.css';
import { useState, useEffect, useRef } from 'react';
import turfCentroid from '@turf/centroid';
import csvDownload from 'json-to-csv-export';
import { DOMParser } from '@xmldom/xmldom';
import { kml as kmlConverter } from '@tmcw/togeojson';
import mapboxgl from 'mapbox-gl';
import turfBbox from '@turf/bbox';

function App() {
    let fileReader;
    const [data, setData] = useState();
    let list = [];
    const mapContainer = useRef(null);
    const map = useRef(null);
    let listId = [];

    const handleFileReadGeoJson = () => {
        const content = fileReader.result;
        const _data = JSON.parse(content);
        setData(_data);

    };

    const handleFileReadKML = () => {
        const content = fileReader.result;
        const parsedKML = new DOMParser().parseFromString(content);
        const _data = kmlConverter(parsedKML);
        setData(_data);
    };
    const handleFileChosen = (file) => {
        setData(null);
        if (file.name.split('.').pop() === 'geojson') {
            fileReader = new FileReader();
            fileReader.onloadend = handleFileReadGeoJson;
            fileReader.readAsText(file);
        } else if (file.name.split('.').pop() === 'kml') {
            fileReader = new FileReader();
            fileReader.onloadend = handleFileReadKML;
            fileReader.readAsText(file);
        }
    };

    const _list = () => {
        const dataToConvert = {
            data: list,
            filename: 'centroid'
        };
        csvDownload(dataToConvert);
    };

    const centroid = () => {
        if (data) {
            list = [];
            if (listId.length === 0) {
                for (const p of data.features) {
                    const c = turfCentroid(p);
                    let coord;
                    coord = {
                        lat: c.geometry.coordinates[1],
                        lon: c.geometry.coordinates[0]
                    };
                    list.push(Object.assign(coord, p.properties));
                }
            } else {
                for (let [index, value] of map.current.getSource('layer')._data.features.entries()) {
                    if (listId.includes(index)) {
                        const c = turfCentroid(value);
                        let coord;
                        coord = {
                            lat: c.geometry.coordinates[1],
                            lon: c.geometry.coordinates[0]
                        };
                        list.push(Object.assign(coord, value.properties));
                    } else {
                        console.log('polygon ', index, ' n\'a pas été sélectionné.');
                    }
                }
            }
            _list();
        } else {
            console.log('no data');
        }
    };

    useEffect(() => {
        if (map.current) {
            return;
        }
        map.current = new mapboxgl.Map({
            container: mapContainer.current,
            style: 'https://vector.getwemap.com/styles/wemap-v1-fr.json',
            center: [2.60, 46.568],
            zoom: 5
        });
    });

    useEffect(() => {
        if (map.current && data) {
            if (map.current.getSource('layer')) {

                map.current.removeLayer('polygon');
                map.current.removeLayer('select');
                map.current.removeSource('layer');

                map.current.addSource('layer', {
                    'type': 'geojson',
                    'data': data,
                    'generateId': true
                });

                map.current.addLayer({
                    'id': 'polygon',
                    'type': 'fill',
                    'source': 'layer',
                    'paint': {
                        'fill-color': '#C4F7FA',
                        'fill-opacity': 0.8,
                        'fill-outline-color': 'rgba(21, 79, 80, 1)'
                    }
                });

                map.current.addLayer({
                    'id': 'select',
                    'type': 'fill',
                    'source': 'layer',
                    'paint': {
                        'fill-color': '#82AAFF',
                        'fill-opacity': 0.8,
                        'fill-outline-color': '#227EE6'
                    },
                    'filter': ['all',
                        ['in', '$id'].concat(listId)
                    ]
                });
            } else {
                map.current.addSource('layer', {
                    'type': 'geojson',
                    'data': data,
                    'generateId': true
                });

                map.current.addLayer({
                    'id': 'polygon',
                    'type': 'fill',
                    'source': 'layer',
                    'paint': {
                        'fill-color': '#C4F7FA',
                        'fill-opacity': 0.8,
                        'fill-outline-color': 'rgba(21, 79, 80, 1)'
                    }
                });

                map.current.addLayer({
                    'id': 'select',
                    'type': 'fill',
                    'source': 'layer',
                    'paint': {
                        'fill-color': '#82AAFF',
                        'fill-opacity': 0.8,
                        'fill-outline-color': '#227EE6'
                    },
                    'filter': ['all',
                        ['in', '$id'].concat(listId)
                    ]
                });
            }

            let bbox = turfBbox(data);
            map.current.fitBounds(bbox);

            map.current.on('click', 'polygon', (e) => {
                map.current.getCanvas().style.cursor = 'pointer';

                if (listId.includes(e.features[0].id)) {
                    listId = listId.filter(function(item) {
                        return item !== e.features[0].id;
                    });
                    map.current.setFilter('select', ['in', '$id'].concat(listId));
                } else {
                    listId.push(e.features[0].id);
                    map.current.setFilter('select', ['in', '$id'].concat(listId));
                }

            });
        }
    });


    return (
        <div className="App">
            <header className="App-header">
                <img
                    className="img-wemap"
                    src="https://getwemap.com/images/logo-wemap.svg"
                    alt="wemap"
                />
                <p>Pour récuperer vos centroids</p>
            </header>
            <div className="Import">
                <input
                    className="btn-input-file"
                    type="file"
                    id="file"
                    accept=".kml,.geojson"
                    onChange={(e) => handleFileChosen(e.target.files[0])}
                />
                <label htmlFor="file"
                    className="btn-importer">
                    Importer
                </label>
                <button className="btn-importer"
                    onClick={(e) => centroid(e)}>
                    Télécharger
                </button>
            </div>
            <div className='map'>
                <div ref={mapContainer}
                    className="map-container"></div>
            </div>
        </div>
    );
}

export default App;
